module.exports = __webpack_public_path__ + "media/bootstrap-icons/caret-up-square-2a88b3a5.svg";